// The arithmetic behind an operator card's "+9% vs peers".
//
// Split out of OperatorStrip so it can be tested without a renderer — the first
// version compared each operator against a median that still included them,
// because filtering the speeds into a shorter list broke the index alignment
// with the rows it was excluding by position.

export const median = (list) => {
  const s = list.filter(v => Number.isFinite(v)).sort((a, b) => a - b);
  if (!s.length) return null;
  const mid = Math.floor(s.length / 2);
  return s.length % 2 ? s[mid] : (s[mid - 1] + s[mid]) / 2;
};

/**
 * Build the per-row peer delta for one set of operators.
 *
 * The baseline is the median of THE OTHERS: including yourself drags it toward
 * you, so the better you are the smaller your own delta looks. The matrices
 * carry a peer median per row for the same reason.
 *
 * @param rows operator-summary rows, `{ _id, avgSpeed }`
 * @returns (row) => percentage above/below the others, or null when there is
 *          nobody to compare against — which is NOT 0%, since that reads as
 *          "exactly average" when the truth is "nobody else ran this"
 */
export function peerDeltaFor(rows = []) {
  const pairs = (Array.isArray(rows) ? rows : [])
    .filter(r => Number.isFinite(r?.avgSpeed))
    .map(r => ({ id: r._id, speed: r.avgSpeed }));

  return (row) => {
    if (!Number.isFinite(row?.avgSpeed) || pairs.length < 2) return null;
    const med = median(pairs.filter(p => p.id !== row._id).map(p => p.speed));
    if (!med) return null;
    return ((row.avgSpeed - med) / med) * 100;
  };
}
